<div class="row mx-0 border-bottom border-top p-2">
  <i class="material-icons pt-1">notifications</i>
  <h1 mat-dialog-title="" class="mat-dialog-title mb-0 pl-2" id="mat-dialog-title-0" *ngIf="!isAddFormVisible && !isEditFormVisible">
    Notifications
  </h1>
  <h1 mat-dialog-title="" class="mat-dialog-title mb-0 pl-2" id="mat-dialog-title-0" *ngIf="isAddFormVisible && !isEditFormVisible">
    Notifications - Add New
  </h1>
  <h1 mat-dialog-title="" class="mat-dialog-title mb-0 pl-2" id="mat-dialog-title-0" *ngIf="isEditFormVisible && !isAddFormVisible">
    Notifications - Edit
  </h1>
</div>
<div class="notificationMainContainer row mx-0">

  <div class="col-12 mt-2 pendingNotification position-absolute">
    <app-pending-notification *ngIf="notificationPendingTag" 
                              [usersInfo]="usersInfo"
                              [notificationList]="notificationList"
                              (onclickuploadCount)="onclickuploadCount($event)"
                              (notificationCount)='notificationCount($event)'>
    </app-pending-notification>
    <app-add-edit-notification  *ngIf="notificationAddEditTag"
                                [usersInfo]="usersInfo"
                                [notificationList]="notificationList"
                                (backClicked)='pendingTagShow($event)'
                                (isSubmitButtonAvailable)='onSubmitButtonAvailable($event)'
                                (isSaveValid)="hasSaveEnable($event)"
                                (addClickInfo)="addClickInfo($event)"
                                (onCancelClick)="onCancelClick($event)"
                                (onClickToBack)="onClickToBack($event)"
                                (onAddLinkClick)="onAddLinkClick($event)"
                                (stepChanged)="onStepChanged($event)"
                                (hasSupplierSelection)="onSupplierSelectionChange($event)"
                                (onEditIconClick)="onEditIconClick($event)">
    </app-add-edit-notification>
  </div>

</div>

<div class="row  mx-0 border-top position-absolute w-100 sg-bottom-btn">
  <div class="col-4 mx-0">
    <button mat-stroked-button class="sg-primary-stroked mat-stroked-button ml-3 mt-2 mr-3" 
    *ngIf="deleteBtn || isDeleteButtonVisisble && isSubmitButtonAvailable"
    (click)="onDeleteClick()">
      Delete
    </button>
    <button mat-stroked-button type="button" class="sg-primary-stroked mat-stroked-button ml-3 mt-2 mr-3"
    *ngIf="isManageList && !isSubmitButtonAvailable"
    (click)="clickManage()">
      Manage
    </button>
  </div>
  <div class="col-8 row mx-0 justify-content-end">
    <button class="mat-primary mat-raised-button mt-2 mr-3" [class.sg-raised-primary]="hasSupplierSelection"
    [disabled]="!hasSupplierSelection"
    *ngIf="isSubmitButtonAvailable && addStep === 1"
     (click)="onNextClick()">
      Next
    </button>
    <button  class="mat-primary mat-raised-button sg-raised-primary mt-2 mr-3" [disabled]="isSaveValid"
    *ngIf="isSubmitButtonAvailable && addStep !== 1"
     (click)="onSaveClick()">
      Save
    </button>
    <button mat-stroked-button="" type="button" (click)="notificationwindowClose()" class="sg-primary-stroked mat-stroked-button mt-2 mr-3">
      {{isSubmitButtonAvailable ? 'Cancel' : 'Close'}}
    </button>
  </div>
</div>